import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <Link
              to="/"
              className="text-2xl md:text-3xl font-extrabold text-background-50 tracking-tight whitespace-nowrap"
            >
              itaobuy<span className="text-primary-400">.rest</span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
              Your trusted gateway to the ItaobuySpreadsheet platform — the smartest way to discover products, compare prices, and shop online with organized spreadsheet tools.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-10">
            <div>
              <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">
                Quick Links
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/itaobuyspreadsheet-guide" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    itaobuy sheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    Shop Now
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">
                Resources
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    Spreadsheet Guide
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    Compare Platforms
                  </a>
                </li>
                <li>
                  <Link to="/itaobuyspreadsheet-guide" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                    Safety Tips
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-300 uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm text-background-400">
              <p>Email: support@itaobuy.rest</p>
              <p>Based in United States</p>
              <p>Available 24/7 Online</p>
            </div>
            <div className="mt-6">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20modern%20shopping%20and%20spreadsheet%20concept%20image%20on%20dark%20background%2C%20clean%20elegant%20composition%2C%20soft%20warm%20glow%2C%20professional%20aesthetic%2C%20no%20harsh%20elements&width=300&height=400&seq=footer-img-v9&orientation=portrait"
                alt="ItaobuySpreadsheet platform"
                className="w-32 h-40 object-cover rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 itaobuy.rest — All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              Disclaimer
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              Privacy
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer"
            >
              Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}